import { render, staticRenderFns } from "./StarsComp.vue?vue&type=template&id=bbd19276"
import script from "./StarsComp.vue?vue&type=script&lang=js"
export * from "./StarsComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports